export default __webpack_public_path__ + "media/images/compaigns/aug_18/transfer-59b9afc485ea7cc3d980390bf6080124.jpg";